/** Player-visible passive content history, versioned by CARDS_VERSION. */
export const DECK_PASSIVE_RELEASES = Object.freeze([
    Object.freeze({
        changeId: 'deck-passives-foundation-set',
        contentVersion: 19,
        releasedAt: null,
        added: Object.freeze([
            'armed_structures',
            'echoing_deployment',
            'energy_reserve',
            'rising_damage',
            'steady_recovery',
        ]),
        updated: Object.freeze([]),
    }),
    Object.freeze({
        changeId: 'echoing-deployment-immediate-echo',
        contentVersion: 51,
        releasedAt: null,
        added: Object.freeze([]),
        updated: Object.freeze(['echoing_deployment']),
    }),
    Object.freeze({
        changeId: 'echoing-deployment-avoids-staged-fields',
        contentVersion: 54,
        releasedAt: null,
        added: Object.freeze([]),
        updated: Object.freeze(['echoing_deployment']),
    }),
]);
const UTC_TIMESTAMP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/u;
function validateJournal(entries) {
    const changeIds = new Set();
    const added = new Set();
    const mentioned = new Set();
    let pendingSeen = false;
    let previousReleasedAt = '';
    for (const entry of entries) {
        if (entry.changeId.trim() === '' || changeIds.has(entry.changeId)) {
            throw new Error(`deck passive releases: duplicate or empty changeId ${entry.changeId}`);
        }
        changeIds.add(entry.changeId);
        if (!Number.isSafeInteger(entry.contentVersion) || entry.contentVersion < 0) {
            throw new Error(`deck passive releases: invalid contentVersion for ${entry.changeId}`);
        }
        if (entry.releasedAt === null)
            pendingSeen = true;
        else {
            if (pendingSeen || !UTC_TIMESTAMP.test(entry.releasedAt)
                || entry.releasedAt < previousReleasedAt) {
                throw new Error(`deck passive releases: invalid release order for ${entry.changeId}`);
            }
            previousReleasedAt = entry.releasedAt;
        }
        const additions = new Set(entry.added);
        const updates = new Set(entry.updated);
        if (additions.size !== entry.added.length || updates.size !== entry.updated.length
            || [...additions].some((id) => updates.has(id))) {
            throw new Error(`deck passive releases: duplicate id in ${entry.changeId}`);
        }
        for (const passiveId of entry.added) {
            if (added.has(passiveId)) {
                throw new Error(`deck passive releases: ${passiveId} added more than once`);
            }
            added.add(passiveId);
            mentioned.add(passiveId);
        }
        for (const passiveId of entry.updated) {
            if (!added.has(passiveId)) {
                throw new Error(`deck passive releases: ${passiveId} updated before addition`);
            }
            mentioned.add(passiveId);
        }
    }
    return mentioned;
}
const JOURNAL_IDS = validateJournal(DECK_PASSIVE_RELEASES);
const ADDED_IDS = new Set(DECK_PASSIVE_RELEASES.flatMap((entry) => entry.added));
export function validateDeckPassiveReleaseCoverage(knownPassiveIds) {
    const known = new Set(knownPassiveIds);
    for (const passiveId of known) {
        if (!ADDED_IDS.has(passiveId)) {
            throw new Error(`deck passive releases: missing addition for ${passiveId}`);
        }
    }
    for (const passiveId of JOURNAL_IDS) {
        if (!known.has(passiveId)) {
            throw new Error(`deck passive releases: unknown passive ${passiveId}`);
        }
    }
}
//# sourceMappingURL=deck-passive-releases.js.map